import type { CfAssetDrag } from './asset'

type Listener = () => void

let current: CfAssetDrag | null = null
const listeners = new Set<Listener>()

export function setCurrentAssetDrag(asset: CfAssetDrag | null) {
  current = asset
  for (const listener of listeners) {
    listener()
  }
}

export function getCurrentAssetDrag() {
  return current
}

export function subscribeAssetDrag(listener: Listener) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
